"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVideoWrapper = exports.StyledResizeStackedCTA = exports.StyledPicture = exports.StyledImageWrapper = exports.StyledIconWrapper = exports.StyledContentWrapper = exports.StyledContentPattern = exports.StyledContentCTA = exports.StyledContentBody = exports.StyledBrandLogos = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _brandLogos = require("../../fuse-brand-logos/src/brand-logos");
var _picture = require("../../fuse-picture/src/picture");
var _grid = require("../../fuse-responsive-grid/src/grid");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledContentPattern = exports.StyledContentPattern = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['imageAlignment', 'imagePosition'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-pattern'
}).withConfig({
  displayName: "styled-content-pattern__StyledContentPattern",
  componentId: "sc-t55vbh-0"
})(["", ""], function (_ref) {
  var imageAlignment = _ref.imageAlignment,
    imagePosition = _ref.imagePosition;
  return "\n\n            width: 100%;\n\n            @media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n                align-items: ").concat(imageAlignment === 'center' ? 'center' : 'start', ";\n                display: flex;\n                flex-flow: ").concat(imagePosition === 'right' ? 'row-reverse' : 'row', ";\n        ");
});
var StyledContentWrapper = exports.StyledContentWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-pattern__content-wrapper',
  'data-testid': 'fuse-content-pattern-content-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledContentWrapper",
  componentId: "sc-t55vbh-1"
})(["display:flex;flex-direction:column;gap:var(--spacing-global-space6);padding:var(--spacing-global-space6) var(--spacing-global-space5);width:100%;@media screen and (min-width:", "){flex:1 1 60%;gap:var(--spacing-global-space7);padding:var(--spacing-global-space7);}@media screen and (min-width:", "){flex:1 1 60%;gap:var(--spacing-global-space8);padding:var(--spacing-global-space8) var(--spacing-global-space9);}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);
var StyledContentBody = exports.StyledContentBody = _styledComponents["default"].div.attrs({
  className: 'fuse-content-pattern__content-body',
  'data-testid': 'fuse-content-pattern-content-body-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledContentBody",
  componentId: "sc-t55vbh-2"
})([""]);
var StyledContentCTA = exports.StyledContentCTA = _styledComponents["default"].div.attrs({
  className: 'fuse-content-pattern__content-cta',
  'data-testid': 'fuse-content-pattern-content-cta-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledContentCTA",
  componentId: "sc-t55vbh-3"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space6);@media screen and (min-width:", "){width:auto;}"], _grid.gridConfig.m.minWidth);
var StyledResizeStackedCTA = exports.StyledResizeStackedCTA = (0, _styledComponents["default"])(_fuseUtils.ResizeStackedCTA).attrs({
  className: 'fuse-content-pattern__resized-content-cta',
  'data-testid': 'fuse-content-pattern-resized-content-cta-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledResizeStackedCTA",
  componentId: "sc-t55vbh-4"
})([""]);
var StyledImageWrapper = exports.StyledImageWrapper = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['imageRatio', 'isPicture'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-pattern__image-wrapper',
  'data-testid': 'fuse-content-pattern-image-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledImageWrapper",
  componentId: "sc-t55vbh-5"
})(["", ""], function (_ref2) {
  var imageRatio = _ref2.imageRatio,
    isPicture = _ref2.isPicture;
  return "\n\n\t\t\twidth: 100%;\n\n\t\t\t".concat(isPicture ? "" : "\n\t\t\t\talign-items: center;\n\t\t\t\taspect-ratio: ".concat(imageRatio ? imageRatio.replace(':', '/') : 'unset', ";\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\tobject-fit: cover;\n\t\t\t"), "\n\n\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\tflex: 1 1 40%;\n\t\t\t}\n\t\t");
});
var StyledPicture = exports.StyledPicture = (0, _styledComponents["default"])(_picture.Picture).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['imageRatio'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-pattern__picture',
  'data-testid': 'fuse-content-pattern-picture-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledPicture",
  componentId: "sc-t55vbh-6"
})(["display:flex;margin:0;& .fuse-picture__img{aspect-ratio:", ";object-fit:cover;width:100%;}"], function (_ref3) {
  var imageRatio = _ref3.imageRatio;
  return imageRatio ? imageRatio.replace(':', '/') : 'unset';
});
var StyledBrandLogos = exports.StyledBrandLogos = (0, _styledComponents["default"])(_brandLogos.BrandLogos).attrs({
  className: 'fuse-content-pattern__brand-logo',
  'data-testid': 'fuse-content-pattern-brand-logo-test-id',
  width: '50%'
}).withConfig({
  displayName: "styled-content-pattern__StyledBrandLogos",
  componentId: "sc-t55vbh-7"
})([""]);
var StyledIconWrapper = exports.StyledIconWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-pattern__icon-wrapper',
  'data-testid': 'fuse-content-pattern-icon-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledIconWrapper",
  componentId: "sc-t55vbh-8"
})(["flex-basis:50%;"]);
var StyledVideoWrapper = exports.StyledVideoWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-pattern__video-wrapper',
  'data-testid': 'fuse-content-pattern-video-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-pattern__StyledVideoWrapper",
  componentId: "sc-t55vbh-9"
})(["width:100%;@media screen and (min-width:", "){flex:1 1 40%;}"], _grid.gridConfig.m.minWidth);